/* eslint-disable react/no-danger */
import React from "react";
import classnames from "classnames";
import { useFeatureFlag } from "@/context/FeatureFlagContext";

// Components
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";

// Util
import getSolutionContent from "./util/getSolutionComponent";

// Styles
import styles from "./contact-us-delivery-solution.module.scss";

function ContactUsDeliverySolution({
  solution: { id, fields, buttonType, hierarchyPosition },
  className,
  contactMethods = {},
}) {
  const showNewProminentLiveChat = useFeatureFlag("show_new_prominent_live_chat");

  const locationOnPage = hierarchyPosition.join(" | ");

  const SolutionComponent = getSolutionContent(id);
  const newDesign = !buttonType;

  return (
    <article
      className={classnames(styles.deliverySolution, styles.deliverySolution__inner, className)}
      data-solution-id={id}
    >
      <div className={styles.deliverySolution__content}>
        <SolutionComponent />
      </div>
      {showNewProminentLiveChat ? (
        <ContactDetailsBox
          title={"We're here to help"}
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          buttonType={buttonType}
          solutionId={id}
          location={locationOnPage}
          contactMethods={contactMethods}
          viewContactDetails={!newDesign}
          directlyDisplayContactMethods
        />
      ) : (
        <ContactDetailsBox
          newDesign={newDesign}
          title={newDesign ? "Did this answer your question?" : "Still need help?"}
          leftButtonText={newDesign ? "No, I need help" : undefined}
          rightButtonText={newDesign ? "Yes, that‘s helpful" : undefined}
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          buttonType={buttonType}
          solutionId={id}
          location={locationOnPage}
          contactMethods={contactMethods}
        />
      )}
    </article>
  );
}

export default ContactUsDeliverySolution;
